import Client from '../HttpClient';

const baseUrl = '/gateway/echidna-api/api/vs';

const list = () => {
	return Client.get(`${baseUrl}/resource/team-user`);
};

const find = (id) => {
	return Client.get(`${baseUrl}/resource/user/${id}`);
};

const invite = (email, merchantId, assignments) => {
	return Client.post(`${baseUrl}/user/invite`, {
		email,
		merchantId,
		assignments,
	});
};

const update = (id, assignments) => {
	return Client.post(`${baseUrl}/resource/${id}`, {
		assignments,
	});
};

const remove = (id, merchantId, branchId) => {
	return Client.post(`${baseUrl}/resource/${id}/del-assign`, {
		merchantId,
		branchId,
	});
};

export default {
	list,
	find,
	invite,
	update,
	remove,
};
